import script from "./AdminSellerViewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSellerViewPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSellerViewPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__